import axios from 'axios'
import ActionsLogin from './LoginActions'

const config = {
  headers: {
    Authorization: 'Bearer ' + ActionsLogin.getToken()
  }
}

const cadastrarCentroDistribuicao = ({
  cd_centro_distribuicao,
  descricao,
  telefone,
  end_cep,
  end_logradouro,
  end_numero,
  end_complemento,
  end_bairro,
  end_cidade,
  end_uf,
  end_pais,
  end_latitude,
  end_longitude,
  idc_status
}) => {
  return axios.post(
    process.env.URL_API_BASE + '/centro-distribuicao',
    {
      cd_centro_distribuicao: cd_centro_distribuicao,
      descricao: descricao,
      telefone: telefone,
      end_cep: end_cep,
      end_logradouro: end_logradouro,
      end_numero: end_numero,
      end_complemento: end_complemento,
      end_bairro: end_bairro,
      end_cidade: end_cidade,
      end_uf: end_uf,
      end_pais: end_pais,
      end_latitude: end_latitude,
      end_longitude: end_longitude,
      idc_status: idc_status
    },
    config
  )
}

const alterarCentroDistribuicao = ({
  id,
  descricao,
  telefone,
  end_cep,
  end_logradouro,
  end_numero,
  end_complemento,
  end_bairro,
  end_cidade,
  end_uf,
  end_pais,
  end_latitude,
  end_longitude,
  idc_status
}) => {
  return axios.patch(
    process.env.URL_API_BASE + '/centro-distribuicao/' + id,
    {
      descricao: descricao,
      telefone: telefone,
      end_cep: end_cep,
      end_logradouro: end_logradouro,
      end_numero: end_numero,
      end_complemento: end_complemento,
      end_bairro: end_bairro,
      end_cidade: end_cidade,
      end_uf: end_uf,
      end_pais: end_pais,
      end_latitude: end_latitude,
      end_longitude: end_longitude,
      idc_status: idc_status
    },
    config
  )
}

const listarCentroDistribuicao = async () => {
  let response = await axios.get(
    process.env.URL_API_BASE + '/centro-distribuicao',
    config
  )
  return response.data
}

export const obterCentroDistribuicao = async id => {
  let response = await axios.get(
    process.env.URL_API_BASE + '/centro-distribuicao/' + id,
    config
  )
  return response.data
}

export default {
  cadastrarCentroDistribuicao,
  alterarCentroDistribuicao,
  listarCentroDistribuicao,
  obterCentroDistribuicao
}



// WEBPACK FOOTER //
// ./src/actions/CentroDistribuicaoActions.js